<template>
  <div class="menu-list">
    <div
      class="menu-item"
      @click="setProject('zh')"
      :class="[project == 'zh' ? 'action' : '']"
    >
      <div class="content">
        <div class="left">
          <img v-if="project == 'zh'" src="@/assets/menu/ax.png" />
        </div>
        <div class="right">
          <div class="image">
            <img v-if="project == 'zh'" src="@/assets/menu/zh_action.png" />
            <img v-else src="@/assets/menu/zh.png" />
          </div>
          <div class="title">综合</div>
        </div>
      </div>
    </div>
    <div
      class="menu-item"
      @click="setProject('jk')"
      :class="[project == 'jk' ? 'action' : '']"
    >
      <div class="content">
        <div class="left">
          <img v-if="project == 'jk'" src="@/assets/menu/ax.png" />
        </div>
        <div class="right">
          <div class="image">
            <img v-if="project == 'jk'" src="@/assets/menu/jk_action.png" />
            <img v-else src="@/assets/menu/jk.png" />
          </div>
          <div class="title">健康</div>
        </div>
      </div>
    </div>
    <div
      class="menu-item"
      @click="setProject('qx')"
      :class="[project == 'qx' ? 'action' : '']"
    >
      <div class="content">
        <div class="left">
          <img v-if="project == 'qx'" src="@/assets/menu/ax.png" />
        </div>
        <div class="right">
          <div class="image">
            <img v-if="project == 'qx'" src="@/assets/menu/qx_action.png" />
            <img v-else src="@/assets/menu/qx.png" />
          </div>
          <div class="title">情绪</div>
        </div>
      </div>
    </div>
    <div
      class="menu-item"
      @click="setProject('pl')"
      :class="[project == 'pl' ? 'action' : '']"
    >
      <div class="content">
        <div class="left">
          <img v-if="project == 'pl'" src="@/assets/menu/ax.png" />
        </div>
        <div class="right">
          <div class="image">
            <img v-if="project == 'pl'" src="@/assets/menu/pl_action.png" />
            <img v-else src="@/assets/menu/pl.png" />
          </div>
          <div class="title">疲劳</div>
        </div>
      </div>
    </div>

    <div
      class="menu-item"
      @click="setProject('js')"
      :class="[project == 'js' ? 'action' : '']"
    >
      <div class="content">
        <div class="left">
          <img v-if="project == 'js'" src="@/assets/menu/ax.png" />
        </div>
        <div class="right">
          <div class="image">
            <img v-if="project == 'js'" src="@/assets/menu/js_action.png" />
            <img v-else src="@/assets/menu/js.png" />
          </div>
          <div class="title">精神</div>
        </div>
      </div>
    </div>
    <div
      class="menu-item"
      @click="setProject('sm')"
      :class="[project == 'sm' ? 'action' : '']"
    >
      <div class="content">
        <div class="left">
          <img v-if="project == 'sm'" src="@/assets/menu/ax.png" />
        </div>
        <div class="right">
          <div class="image">
            <img v-if="project == 'sm'" src="@/assets/menu/sm_action.png" />
            <img v-else src="@/assets/menu/sm.png" />
          </div>
          <div class="title">睡眠</div>
        </div>
      </div>
    </div>

    <div
      class="menu-item"
      @click="setProject('zn')"
      :class="[project == 'zn' ? 'action' : '']"
    >
      <div class="content">
        <div class="left">
          <img v-if="project == 'zn'" src="@/assets/menu/ax.png" />
        </div>
        <div class="right">
          <div class="image">
            <img v-if="project == 'zn'" src="@/assets/menu/zn_action.png" />
            <img v-else src="@/assets/menu/zn.png" />
          </div>
          <div class="title">指南</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      default: "zh",
    },
  },
  methods: {
    setProject(project) {
      this.$emit("setProject", project);
    },
  },
};
</script>

<style scoped lang="scss">
.menu-list {
  .menu-item {
    padding: 10px 0;
    position: relative;
    &::before,
    &::after {
      position: absolute;
      left: 0;
      content: "";
      width: 20px;
      height: 20px;
      border-radius: 100%;
      box-shadow: 0 0 0 10px transparent;
      z-index: 1;
    }
    &::before {
      top: -20px;
      clip-path: inset(50% 50% 0 0);
    }

    &::after {
      bottom: -20px;
      clip-path: inset(0 50% 50% 0);
    }
    &.action {
      background: #fff;
      border-radius: 0 10px 10px 0;
      &::before,
      &::after {
        box-shadow: 0 0 0 10px #fff;
      }
    }
    .content {
      display: flex;
      align-items: center;
      .left {
        width: 6px;
        height: 6px;
        margin-bottom: 15px;
        img {
          width: 6px;
          height: 6px;
        }
      }
      .right {
        margin-left: 10px;
        .image {
          img {
            width: 20px;
            height: 20px;
          }
        }
        .title {
          font-size: 14px;
          color: #89929f;
        }
      }
    }
  }
}
</style>